import React, { memo } from 'react';
import { motion } from 'framer-motion';
import { ToggleRightIcon, EyeIcon, Trash2Icon, LockIcon } from 'lucide-react';
import { DecodeText } from './DecodeText';
const principles = [{
  icon: ToggleRightIcon,
  title: 'User-controlled capture',
  description: 'You start capture. You stop capture. The app never records on its own — every conversation is captured because you chose to capture it.'
}, {
  icon: EyeIcon,
  title: 'Visible when listening',
  description: "Whenever the app is capturing, a clear indicator shows it. You always know exactly when it's on — and when it's off."
}, {
  icon: Trash2Icon,
  title: 'Delete anything, anytime',
  description: 'Remove individual calls, transcripts, or an entire borrower profile in a click. Your data lives on your terms.'
}, {
  icon: LockIcon,
  title: 'Your private call notes',
  description: "These are your private business call notes — built for the loan officer's own memory, not for anyone else's dashboard."
}];
export function Privacy() {
  return <section id="privacy" className="relative overflow-hidden scroll-mt-16 border-t border-slate-100 texture-scanlines py-20 lg:py-28" data-id="element-309">
      <span aria-hidden="true" className="font-mono-brand pointer-events-none absolute -left-10 top-1/2 -translate-y-1/2 -rotate-90 text-[10rem] font-bold tracking-tighter text-slate-900/[0.04] lg:text-[14rem]" data-id="element-310">
        PRIVATE
      </span>
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8" data-id="element-311">
        <motion.div initial={{
        opacity: 0,
        y: 24
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-80px'
      }} transition={{
        duration: 0.6
      }} className="mx-auto max-w-2xl text-center" data-id="element-312">
          <p className="font-mono-brand text-xs uppercase tracking-[0.2em] text-teal-600" data-id="element-313">
            privacy
          </p>
          <h2 className="font-display mt-4 text-3xl font-bold tracking-tight text-ink sm:text-4xl lg:text-5xl" data-id="element-314">
            <DecodeText text="Built to be yours. Controlled by you." data-id="element-315" />
          </h2>
          <p className="mt-5 text-lg leading-8 text-slate-600" data-id="element-316">
            Recall is a tool you run for yourself, on your own desktop. Capture
            is always your call.
          </p>
        </motion.div>

        <div className="mt-14 grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-4" data-id="element-317">
          {principles.map((p, i) => <motion.div key={p.title} initial={{
          opacity: 0,
          y: 24
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-60px'
        }} transition={{
          duration: 0.5,
          delay: i * 0.1
        }} className="rounded-2xl border border-slate-200 bg-white p-6 shadow-sm" data-id="element-318">
              <span className="flex h-11 w-11 items-center justify-center rounded-lg border border-teal-600/30 bg-teal-50" data-id="element-319">
                <motion.span animate={{
              scale: [1, 1.08, 1]
            }} transition={{
              duration: 3,
              repeat: Infinity,
              ease: 'easeInOut'
            }} className="flex" data-id="element-320">
                  <p.icon className="h-5 w-5 text-teal-600" aria-hidden="true" data-id="element-321" />
                </motion.span>
              </span>
              <h3 className="font-display mt-4 text-base font-bold text-slate-900" data-id="element-322">
                {p.title}
              </h3>
              <p className="mt-2 text-sm leading-6 text-slate-600" data-id="element-323">
                {p.description}
              </p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}